module.exports = __webpack_public_path__ + "img/866.3ea2e60d.png";